import { Component, inject } from '@angular/core';
import { ConsumableAcceptedPerActivityService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ConsumableAcceptedPerActivityCreateDto,
  ConsumableAcceptedPerActivityDto,
  ConsumableAcceptedPerActivityExcelDownloadDto,
  ConsumableAcceptedPerActivityUpdateDto,
} from '../proxy/controlling/dtos/consumable-accepted-per-activity';
import { CONSUMABLEACCEPTEDPERACTIVITY_CONFIG, CONSUMABLEACCEPTEDPERACTIVITY_FIELDS } from './consumable-accepted-per-activity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-consumable-accepted-per-activity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConsumableAcceptedPerActivityService, ConfirmationService],
  templateUrl: './consumable-accepted-per-activity.html',
  styleUrl: './consumable-accepted-per-activity.scss',
})
export class ConsumableAcceptedPerActivity extends BaseHierarchicalCrudComponent<
  ConsumableAcceptedPerActivityDto,
  ConsumableAcceptedPerActivityCreateDto,
  ConsumableAcceptedPerActivityUpdateDto,
  ConsumableAcceptedPerActivityExcelDownloadDto
> {
  service = inject(ConsumableAcceptedPerActivityService);
  config = CONSUMABLEACCEPTEDPERACTIVITY_CONFIG;
  fields = CONSUMABLEACCEPTEDPERACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ConsumableAcceptedPerActivityDto): ConsumableAcceptedPerActivityUpdateDto {
    return {
      acceptedQuantity: data.acceptedQuantity,
      activityId: data.activityId,
      consumableId: data.consumableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ConsumableAcceptedPerActivity';
  }
}
